import request from '@/api/request.js'

/**
 * 图片、视频和蜗牛音效包等资源库共用的分类接口。
 */
const fileAssetCategory = {
  list(params) {
    return request({ url: '/admin_file_asset_category/index', method: 'GET', params })
  },

  create(data) {
    return request({ url: '/admin_file_asset_category/create', method: 'POST', data })
  },

  update(data) {
    return request({ url: '/admin_file_asset_category/update', method: 'POST', data })
  },

  delete(data) {
    return request({ url: '/admin_file_asset_category/delete', method: 'POST', data })
  }
}

export default fileAssetCategory

